<template>
  <div>
    <template v-if="contents">
      <div :class="['component', previewSize]" :style="hideAll ? 'display:none' : ''">
        <div @click="isEditing = !isEditing">

          <section :class="sectionClassArray" :style="sectionStyle">
            <div :class="containerClassArray">
              <div :class="['amp-img', 'slide-img', 'amp-img-cover', contents.image.width > contents.image.height ? 'landscape' : 'portrait']">
                <mimic-amp-img :image="contents.image"></mimic-amp-img>
              </div>
            </div>
          </section>

        </div>
      </div>

      <el-dialog width="90%" title="画像の選択" :visible.sync="dialogImageSelectVisible">
        <select-image v-model="selectedImage" @change="onUpdateImage"></select-image>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogImageSelectVisible = false">キャンセル</el-button>
          <el-button type="primary" @click="onUpdateImage">選択</el-button>
        </span>
      </el-dialog>

      <el-form :class="['component-contents-form', ' p2', lock ? 'hide' : isEditing ? 'show' : 'hide']" :model="contents">
        <h2>コンポーネントのコンテンツを編集</h2>
        <el-form-item label="コンポーネント配置順序" label-width="170px">
          <el-input-number v-model="newPosition" controls-position="right" :min="1" :max="positionMax"></el-input-number><span class="pl4">1から{{ positionMax }}まで</span>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="contents.fullWidth">画像を最大幅で表示する</el-checkbox>
        </el-form-item>
        <el-form-item label="リンク先URL" :label-width="labelWidth">
          <el-input class="width-75" v-model="contents.link.href" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="contents.link.blank">リンク先を新たなタブで開く</el-checkbox>
        </el-form-item>
        <el-button @click="onSelectImage(contents.image)">画像の選択</el-button>
        <div class="image-info flex column justify-between items-center">
          <img class="image-info-img" :src="contents.image.src">
          <p class="image-info-size">画像のサイズ：{{ contents.image.width }}x{{ contents.image.height }}</p>
        </div>
        <el-form-item label="スライド上下の余白" :label-width="labelWidth">
           <el-slider v-model="contents.padding.y" :step="1" :min="0" :max="10"></el-slider>
        </el-form-item>
        <el-form-item label="スライド背景色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.bg.isCustom">スライドの背景色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.bg.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.bg.color" show-alpha></el-color-picker>
            <span>{{ contents.bg.color }}</span>
          </div>
        </el-form-item>
        <div class="component-contents-controller flex justify-end items-center">
          <component-form-footer @delete="deleteComponent()" @cancel="isEditing = false" @update="updateComponent()"></component-form-footer>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import ComponentBase from '@/components/mixins/ComponentBase'
import MimicAmpImg from '@/components/mimic-amp/MimicAmpImg'
import SelectImage from '@/components/app/SelectImage'

export default {
  name: 'slide-with-image',
  components: {
    'mimic-amp-img': MimicAmpImg,
    'select-image': SelectImage
  },
  mixins: [ComponentBase],
  data: function () {
    return {
      labelWidth: '11em',
      selectedImage: {
        id: null,
        src: null,
        width: null,
        height: null
      },
      dialogImageSelectVisible: false
    }
  },
  watch: {
    selectedImage: function (newVal) {
      console.log(newVal)
    }
  },
  methods: {
    /**
     * 「画像の選択」ボタンがクリックされたら、contents.imageの各プロパティを
     * this.selectedImageにコピーする
     */
    onSelectImage: function (image) {
      const found = this.media.find(img => img.source_url === image.src)
      if (process.env.NODE_ENV !== 'production') console.log(found)
      image.id = found ? found.id : 0

      this.selectedImage.id = image.id
      this.selectedImage.src = image.src
      this.selectedImage.width = image.width
      this.selectedImage.height = image.height
      this.dialogImageSelectVisible = true
    },
    /**
     * ダイアログで画像を選択したら、選択した画像をidを元にthis.mediaから探し、
     * その画像の情報をthis.contents.imageに格納する
     */
    onUpdateImage: function () {
      const selected = this.media.find(image => image.id === this.selectedImage.id)
      this.contents.image.id = selected.id
      this.contents.image.src = selected.source_url
      this.contents.image.width = selected.media_details.width
      this.contents.image.height = selected.media_details.height
      this.dialogImageSelectVisible = false
    },
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function (contents) {
      const imageDirection = contents.image.width > contents.image.height ? 'landscape' : 'portrait'
      const ampImage = `<amp-img class="slide-img amp-img-cover ${imageDirection}" width="${contents.image.width}" height="${contents.image.height}" layout="responsive" src="${contents.image.src}"></amp-img>`

      let anchor = ''
      if (contents.link.href) {
        anchor += `<a class="SlideImage1-a block" href="${contents.link.href}" ${contents.link.blank ? 'target=_blank' : ''}>${ampImage}</a>`
      } else {
        anchor += `<div>${ampImage}</div>`
      }

      return `
      <section id="${this.sectionId}" class="${this.sectionClass}">
        <div class="${this.containerClass}">
          ${anchor}
        </div>
      </section>
      `.trim().replace(/>\s+</g, '><')
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function (contents) {
      let layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!./${this.meta.file}.scss`)
      let theme = contents.bg.isCustom ? `.${this.meta.file}-${this._uid}-bg{background-color:${contents.bg.color}}` : ''
      return {layout, theme}
    }
  },
  created: async function () {
    // migration
    if (!this.contents.padding) this.contents.padding = {y: 0}
  }
}
</script>

<style lang="scss" scoped>
.native {
  @import './SlideImage1.scss';
}
.smartphone,
.tablet,
.desktop {
  @import './SlideImage1.s.scss';
}
.tablet,
.desktop {
  @import './SlideImage1.m.scss';
}
.desktop {
  @import './SlideImage1.l.scss';
}
</style>


// WEBPACK FOOTER //
// src/components/contents/SlideImage1/SlideImage1.vue